import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const QualityAssurance = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Quality Assurance', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Quality Assurance" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
        <section class="service-details section-space">
  <div class="container">
    <div class="row flex-xl-row flex-column-reverse">
      <div class="col-xl-4">
        <div class="sidebar sidebar-rr-sticky">
          <div class="sidebar__widget-service mb-30">
            <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i> </Link>
            <Link to="/pharmaceutical-details">Pharmaceutical & Biotech industry<i class="fa-solid fa-plus"></i> </Link>
            <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i> </Link>
          </div>

          <div class="sidebar__widget-contact__service text-center">
            <h4 class="mb-25 title-animation text-capitalize">Are You ready to contact with us</h4>
            <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>
            <Link to="/contact-us#" class="rr-btn">
              <span class="btn-wrap">
                <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="service-details__content">
          <div class="service-details__content-media mb-20">
            <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="QA/RA Service" />
          </div>

          <h3 class="title-animation mb-20">Quality Assurance / Regulatory Affairs Service</h3>

          <p class="mb-20">QA/RA services for the medical device industry help ensure product quality and regulatory compliance. Quality Assurance (QA) focuses on building strong quality management systems, performing audits, managing corrective actions, and overseeing supplier quality. Regulatory Affairs (RA) guides companies through regulatory requirements, assists with submissions, ensures proper labeling, and manages post-market compliance. These services help companies meet global standards, keep products safe, and succeed in the market.</p>

          <h3 class="title-animation mb-10">Types of Quality Assurance (QA) Activities:</h3>
          <ul class="mb-30">
            <li><span><i class="fa-solid fa-check"></i></span>Quality Management System (QMS) Implementation</li>
            <li><span><i class="fa-solid fa-check"></i></span>Internal Audits and Gap Analysis</li>
            <li><span><i class="fa-solid fa-check"></i></span>Corrective and Preventive Actions (CAPA) Management</li>
            <li><span><i class="fa-solid fa-check"></i></span>Supplier Quality Management</li>
            <li><span><i class="fa-solid fa-check"></i></span>Document Control and Record Management</li>
            <li><span><i class="fa-solid fa-check"></i></span>Process Validation and Verification</li>
            <li><span><i class="fa-solid fa-check"></i></span>Product Inspection and Testing</li>
            <li><span><i class="fa-solid fa-check"></i></span>Training and Competency Management</li>
            <li><span><i class="fa-solid fa-check"></i></span>Risk Management (ISO 14971 Compliance)</li>
            <li><span><i class="fa-solid fa-check"></i></span>Continuous Improvement Programs</li>
          </ul>

          <h3 class="title-animation mb-10">Types of Regulatory Affairs (RA) Activities:</h3>
          <ul class="mb-30">
            <li><span><i class="fa-solid fa-check"></i></span>Regulatory Strategy Development</li>
            <li><span><i class="fa-solid fa-check"></i></span>Regulatory Submissions (e.g., 510(k), PMA, CE Marking)</li>
            <li><span><i class="fa-solid fa-check"></i></span>Labeling and UDI Compliance</li>
            <li><span><i class="fa-solid fa-check"></i></span>Regulatory Compliance Audits</li>
            <li><span><i class="fa-solid fa-check"></i></span>Post-Market Surveillance</li>
            <li><span><i class="fa-solid fa-check"></i></span>Adverse Event Reporting</li>
            <li><span><i class="fa-solid fa-check"></i></span>Product Classification and Registration</li>
            <li><span><i class="fa-solid fa-check"></i></span>Interface with Regulatory Authorities</li>
            <li><span><i class="fa-solid fa-check"></i></span>Change Management and Regulatory Updates</li>
            <li><span><i class="fa-solid fa-check"></i></span>Regulatory Intelligence and Monitoring</li>
          </ul>

          <h3 class="title-animation mb-10">SQUARE MEDTECH Expertise in QA/RA</h3>
          <p class="mb-30">Enhance your quality and regulatory operations with our expert QA/RA (Quality Assurance and Regulatory Affairs) services. Whether you need to outsource a Quality Manager or require support with specific quality and regulatory matters, SQUARE MEDTECH is here to help.</p>

          <h4 class="title-animation mb-10">How SQUARE MEDTECH can help in QA/RA:</h4>
          <ul class="mb-40">
            <li><span><i class="fa-solid fa-check"></i></span>Provide Outsourced QA/RA Manager</li>
            <li><span><i class="fa-solid fa-check"></i></span>Customized QA/RA support projects</li>
            <li><span><i class="fa-solid fa-check"></i></span>Support for Startups & Institutions</li>
            <li><span><i class="fa-solid fa-check"></i></span>Early-stage regulatory services</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
       
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our QA/RA Services:</h4>
                      <ul class="color-white mb-0">
                        <li>Startup Regulatory Supports</li>
                        <li>Support in Performing Audits</li>
                        <li>Strong Quality Management Systems</li>
                      </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our QA/RA Services:</h4>
                    <ul class="color-white mb-0">
                      <li>Assists in Submissions</li>
                      <li>Corrective Actions Management</li>
                      <li>Customized Regulatory Supports</li>
                    </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
